var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C7.84615 0 5.69481 2.15136 5.69481 4.80519C5.69481 5.02037 5.52037 5.19481 5.30519 5.19481C2.65136 5.19481 0.5 7.34615 0.5 10C0.5 12.6539 2.65136 14.8052 5.30519 14.8052C5.52037 14.8052 5.69481 14.9796 5.69481 15.1948C5.69481 17.8486 7.84615 20 10.5 20C13.1539 20 15.3052 17.8486 15.3052 15.1948C15.3052 14.9796 15.4796 14.8052 15.6948 14.8052C18.3486 14.8052 20.5 12.6539 20.5 10C20.5 7.34615 18.3486 5.19481 15.6948 5.19481C15.4796 5.19481 15.3052 5.02037 15.3052 4.80519C15.3052 2.15136 13.1539 0 10.5 0Z",
    fill: "#60E5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftFlower);
export default __webpack_public_path__ + "static/media/soft_flower.e50066940c6bfa31a9cc4c09cb451eee.svg";
export { ForwardRef as ReactComponent };